import { BaseEntity } from "./BaseEntity";

export class ManufacturerEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.isp.manufacturerList.manufacturer";
        this.pageTitle = "components.settings.permissionManagement.menuList.Manufacturer";
        this.menuPath = "/ISP";
        this.APIRoute = "Resources/ISP/Manufacturer"
        this.i18nBase = "components.isp.manufacturer";
        this.baseEndPoint = "radius/manufacturer";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
            activate: `${this.baseEndPoint}/:id/activate`,
            deactivate: `${this.baseEndPoint}/:id/deactivate`
        };

        this.fields = [
            {
                key: "id",
                label: "user.fields.id",
                type: "text",
                visible: false,
                editable: false,
                orderBy: false
            },
            {
                key: "name",
                label: "common.labels.name",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "name"
            },
            {
                key: "status",
                label: null,
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 12,
                path:"status"
            },
        ]

        this.customActions = {
            duplicate: false
        }

        this.tableColumns = [
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: true
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.pages = {
            edit: {
                pageTitle: `${this.i18nBase}.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/components.settings.permissionManagement.menuList.Manufacturer`,
                route: ["/isp","/isp/manufacturer", "/isp/manufacturer/edit/:id"]
            },
            create: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/components.settings.permissionManagement.menuList.Manufacturer`,
                route: ["/isp","/isp/manufacturer", "/isp/manufacturer/create"]
            },
            list: {
                pageTitle: `components.settings.permissionManagement.menuList.Manufacturer`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP`,
                route: ["/isp", "/isp/manufacturer"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                                path:"status"
                            },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
